<div *transloco="let t; read: 'profile-list'"
  class="spotlight-profile-list-container"
  [attr.aria-hidden]="isFilterMenuOpen">
  <ng-container *ngrxLet="{spotlightProfilesPageData: spotlightProfilesPageData$} as context">
    <sl-profile-list-header [name]="directoryName"
      [totalProfiles]="context.spotlightProfilesPageData.meta.max_available"
      [isInitialLoad]="isInitialLoad"/>

    <div class="content">
      <div class="column-structure">
        <div class="main-panel">
          <div class="top-header">
            <sl-profile-list-search-sort [directoryFilters]="directoryFilters()"
              [showFiltersButton]="showDefaultFilters"
              [isInitialLoad]="isInitialLoad"
              (showFilters)="onShowFilters($event)"/>

            <div class="top-pagination"
              role="region"
              [attr.aria-label]="t('aria_pagination_top')">
              <accredible-pagination [pageMeta]="context.spotlightProfilesPageData.meta"
                (pageChange)="onPageChange($event)"
                [containerStyles]="{ justifyContent: 'space-between' }"
                [jumpToPage]="true"/>
            </div>
          </div>

          <div class="profile-cards-container"
            [class.hide-bottom-border]="!context.spotlightProfilesPageData.profiles.length > 0 || isLoading"
            role="region"
            [attr.aria-label]="t('aria_profile_list')">
            @if (isLoading) {
              <div class="results-page-spinner">
                <mat-spinner class="mobile"
                  [diameter]="50"/>

                <mat-spinner class="desktop"
                  [diameter]="100"/>
              </div>

            } @else if (context.spotlightProfilesPageData.profiles.length > 0 && !pageLimitReached) {
              @for (profile of context.spotlightProfilesPageData.profiles; track profile) {
                <sl-profile-list-card [profile]="profile"/>
              }

            } @else {
              <sl-profile-list-no-results [type]="pageLimitReached ? 'page_limit_reached' : 'no_results'"
                (pageChange)="onPageChange($event)"/>
            }
          </div>

          @if (context.spotlightProfilesPageData.profiles.length > 0 && !isLoading) {
            <div class="bottom-pagination"
              role="region"
              [attr.aria-label]="t('aria_pagination_bottom')">
              <accredible-pagination [pageMeta]="context.spotlightProfilesPageData.meta"
                (pageChange)="onPageChange($event)"
                [jumpToPage]="true"
                [containerStyles]="{ justifyContent: 'space-between' }"/>
            </div>
          }
        </div>

        @if (showAllFilterOptions) {
          <div class="detail-panel">
            <sl-profile-list-filters [showDefaultFilters]="showDefaultFilters"
              [directoryFilters]="directoryFilters()"
              [directoryCustomAttributeFilters]="customAttributeFilters"
              [menuOpen]="isFilterMenuOpen"
              [isInitialLoad]="isInitialLoad"
              (hideFilters)="onHideFilters($event)"/>
          </div>
        }
      </div>
    </div>
  </ng-container>
</div>
